import { PermissionItem } from '../../../services/permissions/permissions.types';
import { ListResponse, TableData } from '../../../shared/types/api-response.types';
import { Observable } from 'rxjs';

export interface UserRole {
  id: number;
  description: string;
  roleName: string;
  email: string;
  externalRoleName: string;
  rolePermissions: PermissionItem[];
}

export interface PermissionsForm {
  resourceValue: {
    text: string;
    value: string;
    subcategory: string;
    isDisabled: boolean;
  };
  resources: {
    resource: { permissionName: string; permissionValue: string };
    state: boolean;
  }[];
}

export interface UserRoleForm {
  description: string;
  roleName: string;
  externalRoleName: string;
  permissions: PermissionsForm[];
}

export interface CreateUserRole {
  description: string;
  roleName: string;
  email?: string;
  externalRoleName: string;
  rolePermissions: {
    permissionValue: string;
    resourceValue: string;
    subCategory: string;
  }[];
}

export type UserRolesTable = TableData<UserRole>;

export abstract class UserRolesPageContext {
  abstract selectedEditItem: UserRole | undefined;
  abstract openModal(): void;
  abstract userRoleDelete(roleId: number): void;
}

export abstract class UserRolesModelContext {
  abstract readonly permissionGroup$: Observable<[boolean, boolean]>;
}
export type UserRolesResponse = ListResponse<UserRole>;
